// extracted by mini-css-extract-plugin
export default {"containerPdf":"ViewerPDF_containerPdf__vsF8U"};